import { Link, useLocation } from "react-router-dom";
import { useSiteSettings } from "@/hooks/useSiteSettings";

const navItems = [
  { icon: "ri-dashboard-3-line", label: "Dashboard", path: "/admin" },
  { icon: "ri-slideshow-3-line", label: "Hero", path: "/admin/hero" },
  { icon: "ri-store-2-line", label: "Marketplaces", path: "/admin/marketplaces" },
  { icon: "ri-shopping-bag-3-line", label: "Produtos", path: "/admin/produtos" },
  { icon: "ri-fire-line", label: "Ofertas do Dia", path: "/admin/ofertas" },
  { icon: "ri-star-line", label: "Produtos em Destaque", path: "/admin/destaques" },
  { icon: "ri-article-line", label: "Artigos & Guias", path: "/admin/artigos" },
  { icon: "ri-apps-2-line", label: "Categorias", path: "/admin/categorias" },
  { icon: "ri-links-line", label: "Links de Afiliado", path: "/admin/links" },
  { icon: "ri-bar-chart-2-line", label: "Relatórios", path: "/admin/relatorios" },
];

const bottomNavItems = [
  { icon: "ri-settings-3-line", label: "Configurações", path: "/admin/configuracoes" },
];

export default function AdminSidebar() {
  const { pathname } = useLocation();
  const { settings } = useSiteSettings();

  return (
    <aside className="w-64 min-h-screen bg-gray-950 flex flex-col flex-shrink-0">
      {/* Logo */}
      <div className="px-6 py-5 border-b border-gray-800">
        <Link to="/" className="flex items-center gap-2">
          {settings.logoUrl ? (
            <img
              src={settings.logoUrl}
              alt={settings.siteName}
              className="h-8 w-auto object-contain"
            />
          ) : (
            <span className="text-lg font-bold text-white">{settings.siteName}</span>
          )}
        </Link>
        <p className="text-xs text-gray-500 mt-1 font-medium tracking-wide uppercase">Painel de Controle</p>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {navItems.map((item) => {
          const isActive =
            item.path === "/admin"
              ? pathname === "/admin"
              : pathname.startsWith(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                isActive
                  ? "bg-orange-500 text-white"
                  : "text-gray-400 hover:bg-gray-800 hover:text-white"
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-base`}></i>
              </div>
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="px-3 py-4 border-t border-gray-800 space-y-1">
        {bottomNavItems.map((item) => {
          const isActive = pathname.startsWith(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                isActive
                  ? "bg-orange-500 text-white"
                  : "text-gray-400 hover:bg-gray-800 hover:text-white"
              }`}
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-base`}></i>
              </div>
              {item.label}
            </Link>
          );
        })}
        <Link
          to="/"
          className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm text-gray-400 hover:bg-gray-800 hover:text-white transition-all cursor-pointer"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-external-link-line text-base"></i>
          </div>
          Ver Site
        </Link>
      </div>
    </aside>
  );
}